import React from 'react'
import { MenuItem } from './MobileMenuComponents.js'
import { useAiuiContext } from '../AiuiProvider/index.js'
import { getLocalizedPath } from '../../helpers/utils.js'

/**
 * 移动端support菜单
 * @param supportsMetadata support菜单元数据
 */
export const MobileSupportMenu = ({ supportsMetadata }: { supportsMetadata: any }) => {
  const { locale = 'us' } = useAiuiContext()
  return (
    <div className="tablet:px-8 laptop:px-16 p-4">
      {supportsMetadata?.map((supportItem: any) => (
        <MenuItem
          key={supportItem.id}
          href={getLocalizedPath(supportItem.url, locale)}
          label={supportItem.label}
          onClick={() => {}}
        />
      ))}
    </div>
  )
}
